export default "__VITE_ASSET__4oL0xKta__"